import Footer from "./Footer";
import TopMenu from "./TopMenu";

const About = () => {
  const datas = 0;
  return (
    <div className="dashBoardStyleMain">
      <TopMenu data={datas} />
      <div className="main_dasbord srollBars">
        <div className="aboutUsPAge">
          <h2>ABOUT US</h2>
          <div className="aboutUsContents">
            <h4>Welcome to News 24*7!</h4>
            <p>
              My name is Raviranjan Sharma, and I'm the developer behind this
              dynamic news platform. As a graduate from MDU, Rohtak, with a
              degree in BCA, I was passionate about showcasing my technical
              skills through a real-world project. That's how News 24/7 was
              born!
            </p>
            <h3>A Well-Structured and Highly Maintainable Platform</h3>
            <p>
              This website is designed with a focus on both user experience and
              ease of maintenance. The code is well-structured, making it easy
              to understand, modify, and extend in the future. This ensures
              long-term sustainability and allows for continuous improvement of
              the platform.
            </p>
            <h3>Powered by MERN Stack for Efficiency and Security</h3>
            <p>
              News 24/7 leverages the power of the MERN stack, a combination of
              robust technologies: MongoDB Atlas: This cloud-based NoSQL
              database efficiently stores and retrieves news data in a flexible
              JSON format. Node.js and Express.js: These server-side
              technologies seamlessly handle API creation, allowing you to fetch
              and process news data from various sources. React.js: This popular
              JavaScript library builds the interactive and visually appealing
              user interface, providing a smooth browsing experience.
            </p>
            <h3>Data Visualization for Enhanced Understanding</h3>
            <p>
              The website features a dedicated dashboard where news information
              is presented through informative graphs and line charts. This
              visual representation helps users quickly grasp trends and
              patterns within the news landscape.
            </p>
            <h3>Granular Filtering for Precise Search</h3>
            <p>
              News 24/7 empowers you to tailor your news consumption experience.
              You can utilize various filtering options: Two-Page Filtering:
              Choose between a comprehensive view of all articles or a dedicated
              page for trending topics. Keyword Sorting: Simply click on any
              trending keyword to instantly sort articles related to that
              specific topic. Eight Filters: Refine your search further using a
              combination of checkboxes, dropdowns, and a search bar. This
              allows for highly granular control over the news you want to see.
            </p>
            <h3>About Us: Bringing You the News You Need</h3>
            <p>
              Here at News 24/7, we believe in providing users with access to
              reliable and timely news, all in an easy-to-navigate and visually
              appealing platform. We're constantly striving to improve the
              website, so your feedback is always welcome!
            </p>
          </div>
          <Footer></Footer>
        </div>
      </div>
    </div>
  );
};

export default About;
